import SuperMultiAutocomplete from 'components/forms/SuperMultiAutocomplete'
import moment from 'moment'
import PropTypes from 'prop-types'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import MultiContactsAutocomplete from 'referencial/components/contact/components/MultiContactsAutocomplete'
import MultiContributorsAutocomplete from 'referencial/components/contributor/components/MultiContributorsAutocomplete'
import i18n from 'simple-react-i18n'
import useSandreList from 'utils/customHook/useSandreList'
import { authorizeContributors, authorizeFilter } from 'utils/HabilitationUtil'
import Input from '../../../../components/forms/Input'
import RadioButtons from '../../../../components/forms/RadioButtons'
import SimpleDatePicker from '../../../../components/forms/SimpleDatePicker'
import Textarea from '../../../../components/forms/Textarea'
import { getCampaignType } from '../../../../utils/CampaignUtil'
import { getDate } from '../../../../utils/DateUtil'
import { hasValue } from '../../../../utils/NumberUtil'
import { i18nize } from '../../../../utils/StringUtil'
import {
    QUALITY_CAMPAIGN_REQUEST,
    QUALITY_CAMPAIGN_TYPES,
} from '../../../constants/CampaignConstants'
import { Card, CardContent, Grid } from '@mui/material'
import { campaignShape } from 'campaign/shapes/CampaignShapes'
import { CardTitle } from '../../../../components/card/NewCard'


const FormQualityCampaign = ({
    campaign = {},
    onChangeCampaign = () => { },
    disabled = true,
    titleActions = [],
}) => {
    const {
        contacts,
        contributors,
        accountUser,
    } = useSelector(store => ({
        contacts: store.ContactReducer.contacts,
        contributors: store.ContributorReducer.contributors,
        accountUser: store.AccountReducer.accountUser,
    }), shallowEqual)

    const {
        beginningApplication,
        endingApplication,
        requestType,
        name,
        campaignType,
        statut,
        contactCode,
        contributorCode,
        recipientCode,
        payerCode,
        samplerCode,
        marketRef,
        comment,
        secondaryContacts,
        secondaryLabos,
    } = campaign
    const startDate = beginningApplication && moment(beginningApplication, 'DD/MM/YYYY').valueOf()
    const endDate = endingApplication && moment(endingApplication, 'DD/MM/YYYY').valueOf()

    const campaignStatus = useSandreList('CAMPAGNES.STATUT')

    return (
        <Card sx={{ height: '100%' }}>
            <CardTitle title={i18n.generalInfos} actions={titleActions} />
            <CardContent>
                <Grid container spacing={1}>
                    <Grid size={6}>
                        <Input
                            title={i18n.name}
                            value={name}
                            onChange={value => onChangeCampaign({ name: value })}
                            disabled={disabled}
                        />
                    </Grid>
                    <Grid size={3}>
                        <SimpleDatePicker
                            id='beginningApplication'
                            label={i18n.startDate}
                            value={startDate}
                            onChange={v => onChangeCampaign({ beginningApplication: getDate(v) !== '' ? getDate(v) : null })}
                            max={endDate}
                            disabled={disabled}
                        />
                    </Grid>
                    <Grid size={3}>
                        <SimpleDatePicker
                            id='endingApplication'
                            label={i18n.endDate}
                            value={endDate}
                            onChange={v => onChangeCampaign({ endingApplication: getDate(v) !== '' ? getDate(v) : null })}
                            min={startDate}
                            disabled={disabled}
                        />
                    </Grid>
                    <Grid size={6}>
                        <RadioButtons
                            elements={i18nize(QUALITY_CAMPAIGN_TYPES)}
                            disabled={disabled}
                            title={i18n.campaignType}
                            selected={getCampaignType(campaignType)}
                            onChange={e => onChangeCampaign({ campaignType: e })}
                        />
                    </Grid>
                    <Grid size={3}>
                        <SuperMultiAutocomplete
                            options={i18nize(QUALITY_CAMPAIGN_REQUEST)}
                            values={parseInt(requestType)}
                            label={i18n.requestType}
                            keyLabel='label'
                            keyValue='code'
                            onChange={value => onChangeCampaign({ requestType: value ? `${value}` : null })}
                            disabled={disabled}
                        />
                    </Grid>
                    <Grid size={3}>
                        <SuperMultiAutocomplete
                            options={campaignStatus}
                            values={statut}
                            label={i18n.status}
                            keyValue='code'
                            onChange={value => onChangeCampaign({ statut: value })}
                            disabled={disabled}
                        />
                    </Grid>
                    <Grid size={12}>
                        <MultiContributorsAutocomplete
                            label={i18n.producer}
                            options={authorizeContributors(contributors, accountUser, parseInt(contributorCode))}
                            onChange={id => onChangeCampaign({ contributorCode: hasValue(id) && `${id}` || undefined })}
                            values={parseInt(contributorCode)}
                            disabled={disabled}
                        />
                    </Grid>
                    <Grid size={12}>
                        <MultiContributorsAutocomplete
                            label={i18n.sampler}
                            options={authorizeContributors(contributors, accountUser, parseInt(samplerCode))}
                            onChange={id => onChangeCampaign({ samplerCode: hasValue(id) && `${id}` || undefined })}
                            values={parseInt(samplerCode)}
                            disabled={disabled}
                        />
                    </Grid>
                    <Grid size={6}>
                        <MultiContributorsAutocomplete
                            label={i18n.laboratory}
                            options={authorizeContributors(contributors, accountUser, parseInt(recipientCode))}
                            onChange={id => onChangeCampaign({ recipientCode: hasValue(id) && `${id}` || undefined })}
                            values={parseInt(recipientCode)}
                            disabled={disabled}
                        />
                    </Grid>
                    <Grid size={6}>
                        <MultiContributorsAutocomplete
                            multiple
                            label={i18n.otherLaboratories}
                            options={authorizeContributors(contributors, accountUser, parseInt(recipientCode))}
                            onChange={ids => onChangeCampaign({ secondaryLabos: ids || [] })}
                            values={secondaryLabos}
                            disabled={disabled}
                        />
                    </Grid>
                    <Grid size={6}>
                        <MultiContactsAutocomplete
                            label={i18n.contact}
                            options={authorizeFilter(contacts, accountUser, contactCode, 'contributor')}
                            onChange={(id) => onChangeCampaign({ contactCode: id })}
                            values={contactCode}
                            limit={5}
                            disabled={disabled}
                        />
                    </Grid>
                    <Grid size={6}>
                        <MultiContactsAutocomplete
                            multiple
                            label={i18n.secondaryContacts}
                            options={authorizeFilter(contacts, accountUser, contactCode, 'contributor')}
                            onChange={ids => onChangeCampaign({ secondaryContacts: ids || [] })}
                            values={secondaryContacts}
                            limit={5}
                            disabled={disabled}
                        />
                    </Grid>
                    <Grid size={6}>
                        <MultiContributorsAutocomplete
                            label={i18n.payer}
                            options={authorizeContributors(contributors, accountUser, parseInt(payerCode))}
                            onChange={id => onChangeCampaign({ payerCode: hasValue(id) && `${id}` || undefined })}
                            values={parseInt(payerCode)}
                            keyLabel='labelDisplay'
                            disabled={disabled}
                        />
                    </Grid>
                    <Grid size={6}>
                        <Input
                            title={i18n.offerCall}
                            value={marketRef}
                            onChange={value => onChangeCampaign({ marketRef: value })}
                            disabled={disabled}
                        />
                    </Grid>
                    <Grid size={12}>
                        <Textarea
                            title={i18n.comment}
                            value={comment}
                            onChange={value => onChangeCampaign({ comment: value })}
                            disabled={disabled}
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

FormQualityCampaign.propTypes = {
    campaign: campaignShape,
    disabled: PropTypes.bool,
    onChangeCampaign: PropTypes.func,
    titleActions: PropTypes.arrayOf(PropTypes.shape({})),
}

export default FormQualityCampaign